import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { PopupMainContent } from "../../components/Popup/Components";
import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import FormInput from "../../components/Form/FormInput/FormInput";
import { uid } from "../../helper";
import moment from "jalali-moment";
import { DetailsInfoCard, DetailsInfoRow } from "../../components/Table/Components";
import { useApp } from "../../hooks/useApp";
import { useCallback, useEffect, useState } from "react";
import SearchableDropdown from "../../components/Form/Dropdown/SearchableDropdown";
import PrimaryButton from "../../components/Form/Button/PrimaryButton";
import FormDatePicker from "../../components/Form/DatePicker/FormDatePicker";
import CommonService from "../../services/common.service";
import { SubscriptionDate } from "../../components/General/SubscriptionDate";

export const UserView = ({data}) => {
    const {t} = useTranslation();
    const {
        countries, 
        defaultCountry
    } = useApp();
    const [provinces, setProvinces] = useState([]);
    const [userCountry, setUserCountry] = useState(null);
    const [userProvince, setUserProvince] = useState(null);
    const initialValues = {
        email: data.email,
        msisdn: `${data?.msisdn_country.flag} (${data?.msisdn_country.dial_code})${data?.msisdn}`,
        first_name: data.first_name,
        last_name: data.last_name,
        country: userCountry,
        province: userProvince,
        date_of_birth: new Date(data.date_of_birth)
    };

    useEffect(() => {
        const country = countries.filter((c) => c.id === data.province.country_id);
        setUserCountry((country.length > 0)?country[0]:defaultCountry);
    }, [data]);
    
    const handleLoadProvinces = async (country) => {
        const data = await CommonService.provinces(country.value);
        const items = [];
        data.map(async (province) => {
            items.push({ label: (province.name), value: province.id })
        });
        return items;
    }
    const onChangeCountry = async (country) => {
        const provincesData = await handleLoadProvinces(country);
        setProvinces(provincesData);
        const province = provincesData.filter((c) => c.value === data.province.id)
        setUserProvince((province.length > 0)?province[0]:null)
        
    }
    

    const validationSchema = Yup.object({
        
    });

    const handleSubmit = (values, actions) => {
        console.log(values)
    };
    return (
        <PopupMainContent $maxWidth="800px">
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formik) => (
                    <Form>
                        <DetailsInfoCard>
                            <DetailsInfoRow>
                                <b>{t("Account Number")}</b> <span><b>{uid(data.uid)}</b></span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Member Since")}</b> <span>{moment(data.created_at).format("D MMMM YYYY HH:mm")}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Current Timezone")}</b> <span>{data.timezone}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Last Login Time")}</b> <span>{moment(data.last_login_at).format("D MMMM YYYY HH:mm")}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Subscription")}</b> 
                                <span>
                                    <SubscriptionDate user={data} />
                                </span>
                            </DetailsInfoRow>
                        </DetailsInfoCard>
                        <Row>
                            <Col md={6}>
                                <FormInput type="text" name="email" theme={"light"} label={t("E-Mail")} forceLTR={true} formik={formik} disabled/>    
                            </Col>
                            <Col md={6}>
                                <FormInput type="text" name="msisdn" theme={"light"} label={t("Phone")} forceLTR={true} formik={formik} disabled/>    
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormInput type="text" name="first_name" theme={"light"} label={t("First Name")} formik={formik}/>    
                            </Col>
                            <Col md={6}>
                                <FormInput type="text" name="last_name" theme={"light"} label={t("Last Name")} formik={formik}/>    
                            </Col>
                        </Row>
                        <Row>
                        <Col md={6}>
                                <SearchableDropdown 
                                    name="country" 
                                    label={t("Country")} 
                                    formik={formik} 
                                    forceLTR={true} 
                                    isRequired={true}
                                    options={countries}
                                    onSelected={onChangeCountry}
                                    defaultValue={userCountry}
                                    theme={"light"}
                                />
                            </Col>
                            <Col md={6}>
                                <SearchableDropdown 
                                    name="province" 
                                    options={provinces} 
                                    label={t("Province/State")} 
                                    formik={formik} 
                                    forceLTR={true} 
                                    isRequired={true}
                                    theme={"light"}
                                    defaultValue={userProvince}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormDatePicker theme={"light"} name="date_of_birth" label={t("Date of Birth")} formik={formik} isRequired={true} />
                            </Col>
                            <Col md={6}>
                                
                            </Col>
                        </Row>
                        {/* <PrimaryButton type="submit" full submitting={formik.isSubmitting}>{t("Update")}</PrimaryButton> */}
                    </Form>
                )}
                
            </Formik>
        </PopupMainContent>
    )
}